import { PRIMARY_PRODUCTS } from "../../data";
import type { PrimaryProduct } from "../../types";

/**
 * Finds the primary product name based on the provided product query parameter
 * @param {string | null} primaryProduct - The primary product query parameter value
 * @returns {string | null} The matched product name or null if not found
 */
export const findPrimaryProduct = (primaryProduct: string | null): PrimaryProduct | null => {
  if (!primaryProduct) {
    return null;
  }

  return PRIMARY_PRODUCTS.find((p) => (p.name.toLowerCase() === primaryProduct.toLowerCase())) ?? null;
};
